/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { Instance } from "mobx-state-tree"
import { SmsAddonFailedDtoModelBase } from "./SmsAddonFailedDtoModel.base"

/* The TypeScript type of an instance of SmsAddonFailedDtoModel */
export interface SmsAddonFailedDtoModelType extends Instance<typeof SmsAddonFailedDtoModel.Type> {}

/* A graphql query fragment builders for SmsAddonFailedDtoModel */
export { selectFromSmsAddonFailedDto, smsAddonFailedDtoModelPrimitives, SmsAddonFailedDtoModelSelector } from "./SmsAddonFailedDtoModel.base"

/**
 * SmsAddonFailedDtoModel
 */
export const SmsAddonFailedDtoModel = SmsAddonFailedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
